export default __webpack_public_path__ + "static/media/YorkIE_Fuel-light-mint.e22a3d86.svg";